export const CHIP_INPUT_ELEMENT = "chip-input-element";
export const ADD_CHIP_ELEMENT = "add-chip-element";
